import React, { useState } from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../../store';
import MediaPickersConstants from '../../../MediaPickersConstants';
import BackgroundVideosOrientationSelect from './BackgroundStockVideosOrientationSelect';
import StockVideosSearch from '../../../common/StockVideosSearch';

const BackgroundStockVideosSearch = (props) => {
    const [contextMenuAnchor, setContextMenuAnchor] = useState(undefined);

    const { 
        backgroundStockVideosOrientation, backgroundStockVideosSearchValue, setProperty, 
        backgroundStockVideosSearching, searchBackgroundStockVideos, clearBackgroundStockVideos, backgroundCatalogVideos, backgroundStockVideos 
    } = props;

    const onSearchValueChange = (event) => {
        setProperty('backgroundStockVideosSearchValue', event.target.value);
    };

    const resetCatalogVideos = () => {
        setProperty('backgroundCatalogVideos',  backgroundCatalogVideos.slice(0, 11));
        setProperty('backgroundCatalogVideosPageNumber', 1);
        setProperty('backgroundCatalogVideosAllCount', 12);
    }

    const loadBackgroundStockVideos = (orientation) => {
        setProperty('backgroundStockVideosSearching', true);
        resetCatalogVideos();

        if (orientation) 
            setProperty('backgroundStockVideosOrientation', orientation);
        
        searchBackgroundStockVideos(backgroundStockVideosSearchValue, (orientation || backgroundStockVideosOrientation), 1, MediaPickersConstants.BACKGROUND_STOCK_VIDEOS_PER_PAGE, () => {
            setProperty('backgroundStockVideoTabVisible', true);
            setProperty('backgroundStockVideosSearching', false);
        });
    };

    const clearResults = () => {
        clearBackgroundStockVideos();
    };

    const onOrientationChange = (orientation) => {
        setContextMenuAnchor(undefined);
        loadBackgroundStockVideos(orientation);
    }

    return (
        <StockVideosSearch
            clearResults={clearResults}
            searchValue={backgroundStockVideosSearchValue}
            isSearching={backgroundStockVideosSearching}
            onSearchValueChange={onSearchValueChange}
            disableClearButton={backgroundStockVideos?.length == 0}
            onSearchValueSubmit={loadBackgroundStockVideos}
            contextMenuAnchor={contextMenuAnchor}
            setContextMenuAnchor={setContextMenuAnchor}
            stockMediaOrientationSelect={<BackgroundVideosOrientationSelect onOrientationChange={onOrientationChange} />}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        backgroundStockVideosSearching, 
        backgroundStockVideosOrientation,
        backgroundStockVideosSearchValue,
        backgroundStockVideos,
        backgroundCatalogVideos
    } = state.mediaPicker;

    return {
        backgroundStockVideosSearching,
        backgroundStockVideosOrientation,
        backgroundCatalogVideos, 
        backgroundStockVideos,
        backgroundStockVideosSearchValue,
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const searchBackgroundStockVideos = (keywords, orientation, pageNumber, itemsPerPage, callback) => dispatch(mediaPickerActions.searchBackgroundStockVideos(keywords, orientation, pageNumber, itemsPerPage, callback));
    const clearBackgroundStockVideos = () => dispatch(mediaPickerActions.clearBackgroundStockVideos());
    
    return { 
        setProperty,
        clearBackgroundStockVideos,
        searchBackgroundStockVideos
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundStockVideosSearch);